import { useTranslation } from 'react-i18next';
import useFormatCurrency from 'hooks/useFormatCurrency';
import MoneyIcon from 'assets/images/screenAndProtect/icons/money.svg?react';
import ThumbsUpIcon from 'assets/images/screenAndProtect/icons/thumbs-up.svg?react';
import GrowthIcon from 'assets/images/screenAndProtect/icons/growth.svg?react';
import CalendarIcon from 'assets/images/screenAndProtect/icons/calendar.svg?react';
import HandsMoneyIcon from 'assets/images/screenAndProtect/icons/hands-money.svg?react';
import GlobalIcon from 'assets/images/screenAndProtect/icons/global.svg?react';
import { BenefitsCards, BenefitCard } from './ScreenAndProtectLanding.styles';

const benefitCards = (formatCurrency: ReturnType<typeof useFormatCurrency>) =>
  [
    {
      icon: MoneyIcon,
      titleKey: 'pageScreenAndProtect.landingPage.benefits.cards.damage.title',
      descriptionKey:
        'pageScreenAndProtect.landingPage.benefits.cards.damage.description',
      titleVariables: {
        amount: formatCurrency({ value: 50000, currency: 'USD' }),
      },
    },
    {
      icon: ThumbsUpIcon,
      titleKey:
        'pageScreenAndProtect.landingPage.benefits.cards.fastResolution.title',
      descriptionKey:
        'pageScreenAndProtect.landingPage.benefits.cards.fastResolution.description',
    },
    {
      icon: GrowthIcon,
      titleKey:
        'pageScreenAndProtect.landingPage.benefits.cards.automatedScreening.title',
      descriptionKey:
        'pageScreenAndProtect.landingPage.benefits.cards.automatedScreening.description',
    },
    {
      icon: CalendarIcon,
      titleKey:
        'pageScreenAndProtect.landingPage.benefits.cards.flexibleFiling.title',
      descriptionKey:
        'pageScreenAndProtect.landingPage.benefits.cards.flexibleFiling.description',
    },
    {
      icon: HandsMoneyIcon,
      titleKey:
        'pageScreenAndProtect.landingPage.benefits.cards.automaticEnrollment.title',
      descriptionKey:
        'pageScreenAndProtect.landingPage.benefits.cards.automaticEnrollment.description',
    },
    {
      icon: GlobalIcon,
      titleKey:
        'pageScreenAndProtect.landingPage.benefits.cards.globalCoverage.title',
      descriptionKey:
        'pageScreenAndProtect.landingPage.benefits.cards.globalCoverage.description',
    },
  ] as const;

const LandingBenefitsCards = () => {
  const { t } = useTranslation();
  const formatCurrency = useFormatCurrency();

  return (
    <BenefitsCards>
      {benefitCards(formatCurrency).map((benefitCard) => {
        const { icon: Icon, titleKey, descriptionKey } = benefitCard;
        const titleVariables =
          'titleVariables' in benefitCard
            ? benefitCard.titleVariables
            : undefined;

        return (
          <BenefitCard key={titleKey}>
            <Icon />
            <h3>{t(titleKey, titleVariables)}</h3>
            <p>{t(descriptionKey)}</p>
          </BenefitCard>
        );
      })}
    </BenefitsCards>
  );
};

export default LandingBenefitsCards;
